module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAfElEQVRIx2N4r61LI8QwavRIM1pfB4RoYfSXdNWv6apUNVpH94MhCH1fJPtjkSyEDRSkjtHf2hV+Hxf/c1EMiICMb+2KRBnNMM+TGJSx2QRidPpmEyK1EGv0xkNqe46o7DmivOGgGpWNDl5nCWGErLegstHkoFGjR43GiwDWSJjRocGnvgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/bf.png
// module id = 780
// module chunks = 0